import { useState } from 'react';

import dynamic from 'next/dynamic';

import { useSearchBarContext } from '@contexts/hotel/SearchBar';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { useDevice } from '@contexts/device';

const SearchBar = dynamic(() => import('./SearchBar'), {
  ssr: false,
});

const ResponsiveListingBox = dynamic(
  () => import('../../listing/utils/ResponsiveListingBox'),
  {
    ssr: false,
  }
);
const HotelSearchBar = () => {
  const { isDesktop } = useDevice();
  const {
    location,
    hotelRoomsList,
    startDate,
    endDate,
    setDates,
    setLocation,
    setIsFetchedItems,
    isStickySearch,
    setHotelRoomsList,
    isLocationEntered,
    setIsLocationEntered,
    setHotelDateSelection,
    isHotelDateSelected,
  } = useSearchBarContext();
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const [hotelRooms, setHotelRooms] = useState<
    Array<ListingSearchRoomInterface>
  >([...hotelRoomsList]);

  const [locationInputVal, setLocationInputVal] = useState<string>('');

  return isDesktop ? (
    <SearchBar
      location={location}
      setDates={setDates}
      startDate={startDate}
      endDate={endDate}
      hotelRoomsList={hotelRoomsList}
      setHotelRoomsList={setHotelRoomsList}
      initialHotelRooms={hotelRooms}
      setInitialHotelRooms={setHotelRooms}
      isLocationEntered={isLocationEntered}
      setIsLocationEntered={setIsLocationEntered}
      setIsFetchedItems={setIsFetchedItems}
      isStickySearch={isStickySearch}
      locationInputVal={locationInputVal}
      setLocation={setLocation}
      setLocationInputVal={setLocationInputVal}
      isDateSelected={isHotelDateSelected}
      setIsDateSelected={setHotelDateSelection}
    />
  ) : (
    <ResponsiveListingBox
      location={location}
      startDate={startDate}
      endDate={endDate}
      hotelRoomsList={hotelRoomsList}
      isModalVisible={isShowModal || isHotelDateSelected}
      toggleIsModalVisible={() => setIsShowModal((val) => !val)}
      hideModal={() => {
        setIsShowModal(false);
        setHotelDateSelection(false);
      }}
    />
  );
};

export default HotelSearchBar;
